import { Component, OnDestroy, OnInit, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

import { ModalClosedReason, ModalContent } from '@ap/modal';
import { SpinnerState, ApSpinnerComponent } from '@ap/spinner';

import { LoaderModalOptions } from './loader-modal.model';

/**
 * @ngdoc component
 * @name ApLoaderModalComponent
 *
 * @description
 * This component is used as content on the modal when openLoader is called
 */
@Component({
    selector: 'ap-loader-modal',
    templateUrl: './loader-modal.component.html',
    styleUrls: ['./loader-modal.component.scss'],
    imports: [ApSpinnerComponent]
})
export class ApLoaderModalComponent extends ModalContent<LoaderModalOptions> implements OnInit, OnDestroy {
    public state = signal<SpinnerState>('loading');
    public subscription = new Subscription();

    public ngOnInit(): void {
        this.subscription.add(
            this.modalOptions.options.readySubject
                .pipe(filter((reason: ModalClosedReason) => reason === ModalClosedReason.ACCEPTED))
                .subscribe(() => this.ready())
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    protected ready(): void {
        this.state.set('completed');
    }
}
